<template>
  <div
    v-if="exportgroup"
    class="section"
  >
    <div class="container">
      <modal-edit-exportgroup-options
        v-if="showEditExportOptions"
        :showModal="showEditExportOptions"
        :exportgroupOptions="exportgroupItems"
        :onClickCancel="hideModal"
        :exportOptionsUpdated="getExportgroupItems"
      ></modal-edit-exportgroup-options>

      <div class="mb-6">
        <div class="buttons">
          <a
            @click="$router.go(-1)"
            class="buttons"
          >
            <span class="icon is-small">
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
            </span>
            <span>{{$t('Views.Settings.ExportgroupDetail.NavButton_Back')}}</span>
          </a>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <ui-section-header
            additionalClass="mb-4"
            :showEdit="true"
            :editFunction="openEditName"
          >

            <template v-slot:title>{{ exportgroup.Name }}</template>
          </ui-section-header>

          <modal-edit-exportgroup-name
            v-if="showEditExportName"
            :showModal="showEditExportName"
            :exportgroup="exportgroup"
            :onClickCancel="hideModal"
            @exportNameUpdated="exportNameUpdated"
          ></modal-edit-exportgroup-name>
        </div>
      </div>

      <div class="columns mb-6">
        <div class="column is-full">
          <ui-section-header
            additionalClass="mb-4"
            :showEdit="false"
            :editFunction="openEditOptions"
          >

            <template v-slot:title>{{$t('Views.Settings.ExportgroupDetail.HeaderTitle_Options')}}</template>
          </ui-section-header>

          <div class="columns">
            <div class="column is-half">
              <table class="table is-fullwidth is-striped is-narrow is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in filteredItems(1, 2, 'Option')"
                    :key="index"
                  >
                    <td>
                      {{ item.Name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="column is-half">
              <table class="table is-fullwidth is-striped is-narrow is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in filteredItems(2, 2, 'Option')"
                    :key="index"
                  >
                    <td>
                      {{ item.Name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Message
            v-if="showMessageNoOptions"
            :message="$t('Views.Settings.ExportgroupDetail.Message_NoOptions')"
          />
        </div>
      </div>

      <div class="columns mb-6">
        <div class="column is-full">
          <ui-section-header
            additionalClass="mb-4"
            :showEdit="false"
          >
            <template v-slot:title>{{$t('Views.Settings.ExportgroupDetail.HeaderTitle_Meetingspaces')}}</template>
          </ui-section-header>

          <div class="columns">
            <div class="column is-half">
              <table class="table is-fullwidth is-striped is-narrow is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in filteredItems(1, 2,'Meetingspace')"
                    :key="index"
                  >
                    <td>
                      {{ item.Name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="column is-half">
              <table class="table is-fullwidth is-striped is-narrow is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in filteredItems(2, 2, 'Meetingspace')"
                    :key="index"
                  >
                    <td>
                      {{ item.Name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Message
            v-if="showMessageNoMeetingSpaces"
            :message="$t('Views.Settings.ExportgroupDetail.Message_NoMeetingspaces')"
          />
        </div>
      </div>

      <div class="columns mb-6">
        <div class="column is-full">
          <ui-section-header
            additionalClass="mb-4"
            :showEdit="false"
          >

            <template v-slot:title>{{$t('Views.Settings.ExportgroupDetail.HeaderTitle_Workspaces')}}</template>
          </ui-section-header>

          <div class="columns">
            <div class="column is-full">
              <table class="table is-fullwidth is-striped is-narrow is-hoverable">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in filteredItems(1,1,'Workspace')"
                    :key="index"
                  >
                    <td>
                      {{ item.Name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <Message
            v-if="showMessageNoWorkSpaces"
            :message="$t('Views.Settings.ExportgroupDetail.Message_NoWorkspaces')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import exportGroupProvider from "@/providers/exportgroup";
import ModalEditExportgroupName from '@/components/Settings/Exportgroups/ModalEditExportgroupName';
import ModalEditExportgroupOptions from '@/components/Settings/Exportgroups/ModalEditExportGroupOptions'
const Message = () => import(/* webpackChunkName: "settings-options" */ '@/components/UI/Message')


export default {
  components: {
    "modal-edit-exportgroup-name": ModalEditExportgroupName,
    "modal-edit-exportgroup-options": ModalEditExportgroupOptions,
    Message
  },

  data() {
    return {
      exportgroup: null,
      exportgroupItems: [],
      exportgroupId: Number(this.$route.params.exportgroupId),
      items: [],
      showEditExportName: false,
      showEditExportOptions: false
    };
  },

  created() {
    this.getExportgroup()
    this.getExportgroupItems();
  },

  computed: {
    showMessageNoOptions() {
      return this.filteredItems(1, 2, 'Option').length === 0 && this.filteredItems(2, 2, 'Option').length === 0
    },
    showMessageNoMeetingSpaces() {
      return this.filteredItems(1, 2, 'Meetingspace').length === 0 && this.filteredItems(2, 2, 'Meetingspace').length === 0
    },
    showMessageNoWorkSpaces() {
      return this.filteredItems(1, 1, 'Workspace').length === 0
    }
  },

  methods: {
    //berekent hoeveel items er over n columns verdeeld moeten worden.
    filteredItems(column, columns, type) {
      let exportOptions = this.exportgroupItems.filter(option => option.ItemType === type && option.IsDeleted === false)
      const total = exportOptions.length;
      const gap = Math.ceil(total / columns);
      let top = (gap * column);
      const bottom = ((top - gap));
      top -= 1;

      return exportOptions.filter(item => exportOptions.indexOf(item) >= bottom && exportOptions.indexOf(item) <= top);
    },

    getExportgroup() {
      let self = this

      exportGroupProvider.methods
        .getExportgroupById(this.exportgroupId)
        .then((response) => {
          if (response.status === 200) {
            self.exportgroup = response.data
          }
        })
    },

    getExportgroupItems() {
      let self = this

      exportGroupProvider.methods
        .getExportgroupItems(this.exportgroupId)
        .then((response) => {
          if (response.status === 200) {
            self.exportgroupItems = response.data
          }
        })
    },

    exportNameUpdated(response) {
      this.exportgroup.Name = response.Name
    },

    openEditName() {
      this.showEditExportName = true
    },

    openEditOptions() {
      this.showEditExportOptions = true
    },

    hideModal() {
      this.showEditExportName = false
      this.showEditExportOptions = false
    },
  }
};
</script>
